// extracted by mini-css-extract-plugin
var _1 = "tjs-map-interaction-window__btn tjs-_buttons__btn tjs-_buttons__btn-primary";
var _2 = "tjs-map-interaction-window__content";
var _3 = "tjs-map-interaction-window__isActive";
var _4 = "tjs-map-interaction-window__window";
export { _1 as "btn", _2 as "content", _3 as "isActive", _4 as "window" }
export default { "btn": _1, "content": _2, "isActive": _3, "window": _4 }
